<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <span class="balance">{{ crystalBalance }}</span>
      <img class="avatar" src="./images/avatar.webp" alt="" />
      <img
        class="tab-one"
        src="./images/tab-one-active.png"
        alt=""
        v-show="drawNumber === 1"
        @click="selectDrawNumber(1)"
      />
      <img
        class="tab-one"
        src="./images/tab-one.png"
        alt=""
        v-show="drawNumber === 10"
        @click="selectDrawNumber(1)"
      />
      <img
        class="tab-ten"
        src="./images/tab-ten-active.png"
        v-show="drawNumber === 10"
        alt=""
        @click="selectDrawNumber(10)"
      />
      <img
        class="tab-ten"
        src="./images/tab-ten.png"
        alt=""
        v-show="drawNumber === 1"
        @click="selectDrawNumber(10)"
      />
      <div class="lucky-draw-box">
        <LuckyGrid
          ref="luckyDraw"
          :width="luckyDrawConfig.width"
          :height="luckyDrawConfig.height"
          :prizes="luckyDrawConfig.prizes"
          :rows="luckyDrawConfig.rows"
          :cols="luckyDrawConfig.cols"
          :blocks="luckyDrawConfig.blocks"
          :buttons="luckyDrawConfig.buttons"
          :speed="luckyDrawConfig.speed"
          :active-style="luckyDrawConfig.activeStyle"
          @start="handleStart"
          @end="endLuckDraw"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';

export default {
  name: 'ActivityPage',
  data() {
    return {
      activityData: {},
      crystalBalance: 0, // 糖果數量
      costNumber: 300, //单次抽奖需要花费
      drawLoading: false,
      prizeList: [
        //九宫格的第一位 index=0
        {
          code: 'P08',
          name: '甜寶頭像框（1天）'
        },
        {
          code: 'P06',
          name: '60幣優惠券（滿300減60）'
        },
        {
          code: 'P07',
          name: '甜爸頭像框（1天）'
        },
        {
          code: 'P02',
          name: '會員50積分'
        },
        {
          code: 'P03',
          name: '魔法兔兔头像框（永久）'
        },
        {
          code: 'P05',
          name: '6666钻'
        },
        {
          code: 'P04',
          name: '魔法兔兔头像框（1天）'
        },
        {
          code: 'P01',
          name: '會員20積分'
        }
      ],
      drawNumber: 1, //抽奖次数
      drawResult: [], //抽奖结果
      isTest: false, //  是否测试模式
      emptyCode: 'P09', //为谢谢惠顾时的代码
      errorResponse: {},
      isFinish: true
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),
    //转盘设置
    luckyDrawConfig() {
      return {
        width: '913px',
        height: '851px',
        rows: 3,
        cols: 3,
        blocks: [
          {
            padding: '160px 100px 160px 180px',
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/draw-bg.png'),
                width: '100%',
                height: '100%'
              }
            ]
          }
        ],
        prizes: [
          {
            x: 0,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/1.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active1.png')
              }
            ]
          },
          {
            x: 1,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/2.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active2.png')
              }
            ]
          },
          {
            x: 2,
            y: 0,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/3.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active3.png')
              }
            ]
          },
          {
            x: 2,
            y: 1,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/4.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active4.png')
              }
            ]
          },
          {
            x: 2,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/5.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active5.png')
              }
            ]
          },
          {
            x: 1,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/6.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active6.png')
              }
            ]
          },
          {
            x: 0,
            y: 2,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/7.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active7.png')
              }
            ]
          },
          {
            x: 0,
            y: 1,
            imgs: [
              {
                src: require('@/activities/candies-draw5/images/8.png'),
                width: '170px',
                height: '189px',
                activeSrc: require('@/activities/candies-draw5/images/active8.png')
              }
            ]
          }
        ],
        activeStyle: {
          background: 'transparent'
        },
        buttons: [
          {
            x: 1,
            y: 1,
            imgs: [
              {
                src: this.drawLoading
                  ? require('@/activities/candies-draw5/images/button.png')
                  : require('@/activities/candies-draw5/images/button.png'),
                width: '170px',
                height: '170px'
              }
            ]
          }
        ]
      };
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (this.isFinish) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          // this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        let data = {};
        if (this.isTest) {
          data = {
            crystalBalance: 3000
          };
        } else {
          const result = await this.$http.get(
            '/activity/getActivityLotteryInfo',
            {
              dictType: 'lotteryConf'
            }
          );
          data = result.data;
        }
        this.crystalBalance = data.crystalBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 檢查登入
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async handleStart() {
      if (!this.isTest) {
        if (this.isFinish) {
          this.showFinishedDialog();
          return;
        }
        if (this.drawLoading) return;
        await this.checkLogin();
      }
      this.showDrawNumberDialog();
    },
    showDrawNumberDialog() {
      this.$confirm({
        content: `抽獎需${this.costNumber * this.drawNumber}個糖果`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickOverlay: false
      })
        .then(() => {
          this.startLuckDraw();
        })
        .catch(() => {});
    },
    // 點選抽獎按鈕會觸發start回調
    async startLuckDraw() {
      if (this.crystalBalance >= this.costNumber * this.drawNumber) {
        this.getDrawResult();
      } else {
        this.$confirm({
          title: '糖果不足',
          content: `抽獎需${this.costNumber * this.drawNumber}個糖果`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    },
    // 獲取抽獎結果
    async getDrawResult() {
      this.$refs.luckyDraw.play();
      this.drawLoading = true;
      this.drawResult = [];
      try {
        let data = '[]';
        await new Promise(resolve => setTimeout(resolve, 2000));
        if (this.isTest) {
          data =
            '[{"name":"P08","count":1},{"name":"P07","count":3},{"name":"P06","count":1},{"name":"P05","count":3}]';
          // data = '[{"name":"P02","count":1}]';
        } else {
          const result = await this.$http.get('/activity/lottery', {
            dictType: 'lotteryConf',
            count: this.drawNumber
          });
          data = result.data;
        }
        if (data) {
          this.drawResult = JSON.parse(data) || [];
          this.crystalBalance =
            this.crystalBalance - this.costNumber * this.drawNumber;
          if (!this.isTest) {
            this.setAccount();
          }
          this.stopDraw();
        }
      } catch (error) {
        this.errorResponse = error;
        if (error && error.msg) {
          this.$message(error.msg);
        }
        this.$refs.luckyDraw.stop(0);
        this.drawLoading = false;
      }
    },
    stopDraw() {
      const drawCode =
        this.drawNumber === 1
          ? this.drawResult[0].name
          : this.drawResult[this.drawResult.length - 1].name;
      const drawIndex = this.prizeList.findIndex(item => {
        return item.code == drawCode;
      });
      console.log(drawIndex);
      // 調用stop停止旋轉並傳遞中獎索引
      this.$refs.luckyDraw.stop(drawIndex);
      this.drawLoading = false;
    },
    endLuckDraw() {
      let drawName = '';
      if (
        this.drawResult.length === 0 ||
        (this.drawResult.length === 1 &&
          this.drawResult[0].name === this.emptyCode)
      ) {
        this.$confirm({
          content: `祝你好运`,
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      } else {
        this.drawResult.forEach(item => {
          const prize = this.prizeList.find(prize => {
            return prize.code == item.name;
          });
          if (prize) {
            if (prize.code !== this.emptyCode) {
              drawName = `${drawName}${prize.name}*${1 * item.count}<br />`;
            }
          }
        });
        drawName = drawName.slice(0, -1);
        this.$confirm({
          content: `
          ${drawName}
          `,
          title: '恭喜你抽中了',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      }
      this.$refs.luckyDraw.init();
    },
    selectDrawNumber(drawNumber) {
      this.drawNumber = drawNumber;
      this.handleStart();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #d3ffff;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .balance {
      position: absolute;
      top: 1790px;
      right: 253px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #681260;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
    }
    .lucky-draw-box {
      text-align: left;
      display: block;
      width: 839px;
      position: absolute;
      top: 2042px;
      left: 70px;
    }
    .avatar {
      position: absolute;
      top: 640px;
      left: 346px;
      width: 270px;
      height: 270px;
    }
    .tab-one,
    .tab-ten {
      position: absolute;
      top: 1955px;
      width: auto;
      height: 118px;
    }
    .tab-one {
      left: 197px;
    }
    .tab-ten {
      right: 200px;
    }
  }
}
</style>
